var map = {
	"./LOGOadmin.png": "5bf1",
	"./calen.png": "945d",
	"./clock.png": "fa24",
	"./d.png": "b9d3",
	"./doc.png": "af4b",
	"./id.png": "9131",
	"./mdp.png": "eaf1",
	"./person.png": "e914",
	"./settingsLanding.png": "6192",
	"./virus.png": "f6b3",
	"./warning.png": "e57e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";